import RestModule from "../vue-ocom/store/RestModule";
import schema from "./schema/index";
import CreateUserModule from "../vue-ocom/store/CreateUserModule";

import * as CONFIG from "../config.js";
var root_url = CONFIG.root_url;

const UserModule = CreateUserModule(root_url);

const PostModule = RestModule(root_url + "/news/post/", schema.Post);
const CommentModule = RestModule(root_url + "/news/comment/", schema.Comment);
//Add more modules here if needed. These will automatically be included and available in main store.

export default {
  UserModule,

  PostModule,
  CommentModule,
  //Add more modules here
};
